"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getStarRating = exports.getPaymentsDetails = exports.getProductCategory = exports.getSoftwareCost = exports.getHardwareCost = exports.getPaymentsCost = exports.getPriceFrequency = exports.getPriceDetails = exports.getPrice = exports.getBonusDetails = exports.getBonus = exports.getName = exports.getProductReviewLink = exports.getLearnMoreLink = exports.getIssuerReviewLink = exports.getIssuerName = exports.getImageAltText = exports.getImageSrc = exports.getCtaText = void 0;

var _get2 = _interopRequireDefault(require("lodash/get"));

var _generalUtils = require("./common/general-utils");

/**
 * Get the cta text of the entity.
 * @param {Object} marketplaceEntity The marketplace entity
 * @return {string} The cta text
 */
var getCtaText = function getCtaText(marketplaceEntity) {
  return (0, _get2.default)(marketplaceEntity, 'details.cta_text.value');
};
/**
 * Get the URL of the logo.
 * @param {Object} marketplaceEntity The marketplace entity
 * @return {string} The logo URL
 */


exports.getCtaText = getCtaText;

var getImageSrc = function getImageSrc(marketplaceEntity) {
  return (0, _get2.default)((0, _generalUtils.getInstitution)(marketplaceEntity), 'details.logo_url.value');
};
/**
 * Get the logo alt text.
 * @param {Object} marketplaceEntity The marketplace entity
 * @return {string} The alt text for the logo.
 */


exports.getImageSrc = getImageSrc;

var getImageAltText = function getImageAltText(marketplaceEntity) {
  return getIssuerName(marketplaceEntity);
};
/**
 * Get the issuer name.
 * @param {Object} marketplaceEntity The marketplace entity
 * @return {string} The review link.
 */


exports.getImageAltText = getImageAltText;

var getIssuerName = function getIssuerName(marketplaceEntity) {
  return (0, _get2.default)((0, _generalUtils.getInstitution)(marketplaceEntity), 'details.name.value');
};
/**
 * Get the issuer review link.
 * @param {Object} marketplaceEntity The marketplace entity
 * @return {string} The review link.
 */


exports.getIssuerName = getIssuerName;

var getIssuerReviewLink = function getIssuerReviewLink(marketplaceEntity) {
  return (0, _get2.default)((0, _generalUtils.getInstitution)(marketplaceEntity), 'details.review_url.value');
};
/**
 * Get the "learn more" / review link.
 * @param {Object} marketplaceEntity The marketplace entity
 * @return {string} The "learn more" / review link.
 */


exports.getIssuerReviewLink = getIssuerReviewLink;

var getLearnMoreLink = function getLearnMoreLink(marketplaceEntity) {
  return getProductReviewLink(marketplaceEntity);
};
/**
 * Get the product review link.
 * @param {Object} marketplaceEntity The marketplace entity
 * @return {string} The review link.
 */


exports.getLearnMoreLink = getLearnMoreLink;

var getProductReviewLink = function getProductReviewLink(marketplaceEntity) {
  return (0, _get2.default)((0, _generalUtils.getProduct)(marketplaceEntity), 'details.review_url.value');
};
/**
 * Get the name of the product / service provided.
 * @param {Object} marketplaceEntity The marketplace entity
 * @returns {String} The name
 */


exports.getProductReviewLink = getProductReviewLink;

var getName = function getName(marketplaceEntity) {
  return (0, _get2.default)(marketplaceEntity, 'details.name.value');
};
/**
 * Get the bonus value.
 * @param {Object} marketplaceEntity The marketplace entity
 * @returns {String} The bonus value
 */


exports.getName = getName;

var getBonus = function getBonus(marketplaceEntity) {
  return (0, _get2.default)(marketplaceEntity, 'details.bonus.value');
};
/**
 * Get the bonus details.
 * @param {Object} marketplaceEntity The marketplace entity
 * @returns {String} The bonus details
 */


exports.getBonus = getBonus;

var getBonusDetails = function getBonusDetails(marketplaceEntity) {
  return (0, _get2.default)(marketplaceEntity, 'details.bonus_details.value');
};
/**
 * Get the price value.
 * @param {Object} marketplaceEntity The marketplace entity
 * @returns {Number} The price value
 */


exports.getBonusDetails = getBonusDetails;

var getPrice = function getPrice(marketplaceEntity) {
  return (0, _get2.default)(marketplaceEntity, 'details.price.value');
};
/**
 * Get the price details.
 * @param {Object} marketplaceEntity The marketplace entity
 * @returns {String[]} The price details
 */


exports.getPrice = getPrice;

var getPriceDetails = function getPriceDetails(marketplaceEntity) {
  return (0, _get2.default)(marketplaceEntity, 'details.price_details.value');
};
/**
 * Get the price frequency value.
 * @param {Object} marketplaceEntity The marketplace entity
 * @returns {String} The price frequency value
 */


exports.getPriceDetails = getPriceDetails;

var getPriceFrequency = function getPriceFrequency(marketplaceEntity) {
  return (0, _get2.default)(marketplaceEntity, 'details.price_frequency.value');
};
/**
 * Get the payments cost value.
 * @param {Object} marketplaceEntity The marketplace entity
 * @returns {String} The payments cost value
 */


exports.getPriceFrequency = getPriceFrequency;

var getPaymentsCost = function getPaymentsCost(marketplaceEntity) {
  return (0, _get2.default)(marketplaceEntity, 'details.payments_cost.value');
};
/**
 * Get the hardware cost value.
 * @param {Object} marketplaceEntity The marketplace entity
 * @returns {String} The hardware cost value
 */


exports.getPaymentsCost = getPaymentsCost;

var getHardwareCost = function getHardwareCost(marketplaceEntity) {
  return (0, _get2.default)(marketplaceEntity, 'details.hardware_cost.value');
};
/**
 * Get the software cost value.
 * @param {Object} marketplaceEntity The marketplace entity
 * @returns {Number} The software cost value
 */


exports.getHardwareCost = getHardwareCost;

var getSoftwareCost = function getSoftwareCost(marketplaceEntity) {
  return (0, _get2.default)(marketplaceEntity, 'details.software_cost.value');
};
/**
 * Get the product category value.
 * @param {Object} marketplaceEntity The marketplace entity
 * @returns {Number} The product category value
 */


exports.getSoftwareCost = getSoftwareCost;

var getProductCategory = function getProductCategory(marketplaceEntity) {
  return (0, _get2.default)(marketplaceEntity, 'product.details.category.value');
};
/**
 * Get the payments details value.
 * @param {Object} marketplaceEntity The marketplace entity
 * @returns {Number} The payments details value
 */


exports.getProductCategory = getProductCategory;

var getPaymentsDetails = function getPaymentsDetails(marketplaceEntity) {
  return (0, _get2.default)(marketplaceEntity, 'details.payments_details.value');
};
/**
 * Gets star rating.
 * @param      {Object}  marketplaceEntity  The marketplace entity.
 * @return     {number}                     The star rating.
 */


exports.getPaymentsDetails = getPaymentsDetails;

var getStarRating = function getStarRating(marketplaceEntity) {
  return (0, _get2.default)(marketplaceEntity, 'details.star_rating.value');
};

exports.getStarRating = getStarRating;